import { render } from "./live-chat.vue?vue&type=template&id=2a58f97e&scoped=true"
import script from "./live-chat.vue?vue&type=script&lang=js"
export * from "./live-chat.vue?vue&type=script&lang=js"

import "./live-chat.vue?vue&type=style&index=0&id=2a58f97e&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a58f97e"]])

export default __exports__